/**
 * Bus
 *
 * Create a Vue bus to exchange events between components
 *
 * @package Monapix
 * @version 3.0.1
 * @author Binary Cats Inc.
 */

import Vue from 'vue';

window.Bus = new Vue({
    name: 'Bus'
});



// WEBPACK FOOTER //
// ./resources/js/services/bus.js